// Home-page module cards (visual redesign — same flows as before):
//  - AIChatCard: "General Maritime Chat" → opens ChatView for 'general'
//  - MyManualsCard: opens the same My Manuals overlay as the header button
//  - LockedCard: what logged-out visitors see instead of member modules
import { useState } from 'react';
import ChatView from '../chat/ChatView';
import FullPageOverlay from './FullPageOverlay';
import { ManualsOverlay } from '../manuals/ManualsButton';

const CHAT_ACCENT = {
  '--card-accent': '#3b6fe0',
  '--card-accent-soft': '#3b6fe01a',
  '--card-accent-border': '#3b6fe04d',
};
const MANUALS_ACCENT = {
  '--card-accent': '#0e7490',
  '--card-accent-soft': '#0e74901a',
  '--card-accent-border': '#0e74904d',
};

export default function AIChatCard() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="cat-card" style={CHAT_ACCENT} onClick={() => setOpen(true)}>
        <span className="cat-badge">● ACTIVE</span>
        <div className="cat-icon" style={{ fontSize: 24 }}>
          🌊
        </div>
        <div className="cat-title">General Maritime Chat</div>
        <div className="cat-desc">
          Ask general marine engineering and regulatory questions — answers from the shared
          knowledge base.
        </div>
        <div className="cat-foot">
          NO MANUAL NEEDED <span className="arrow">→</span>
        </div>
      </div>
      {open && (
        <FullPageOverlay label="General Maritime Chat">
          <ChatView
            equipmentPath="general"
            title="General Maritime Assistant"
            onBack={() => setOpen(false)}
          />
        </FullPageOverlay>
      )}
    </>
  );
}

export function MyManualsCard() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <div className="cat-card" style={MANUALS_ACCENT} onClick={() => setOpen(true)}>
        <span className="cat-badge">● ACTIVE</span>
        <div className="cat-icon" style={{ fontSize: 24 }}>
          📚
        </div>
        <div className="cat-title">My Manuals</div>
        <div className="cat-desc">
          Upload your equipment PDF manuals and chat with answers grounded in your own
          documentation.
        </div>
        <div className="cat-foot">
          UPLOAD · INDEX · CHAT <span className="arrow">→</span>
        </div>
      </div>
      {open && <ManualsOverlay onClose={() => setOpen(false)} />}
    </>
  );
}

// Placeholder card for logged-out visitors: same shape, prompts to log in.
export function LockedCard({ icon, title, description }) {
  return (
    <div className="cat-card" style={{ ...CHAT_ACCENT, cursor: 'default', opacity: 0.9 }}>
      <span
        className="cat-badge"
        style={{
          color: 'var(--yellow)',
          backgroundColor: 'rgba(161,98,7,0.08)',
          border: '1px solid rgba(161,98,7,0.3)',
        }}
      >
        🔒 LOG IN
      </span>
      <div className="cat-icon" style={{ fontSize: 24 }}>
        {icon}
      </div>
      <div className="cat-title">{title}</div>
      <div className="cat-desc">{description}</div>
      <div className="cat-foot">USE THE LOG IN BUTTON ABOVE ↗</div>
    </div>
  );
}
